//In Login.jsx
import React, { useState } from 'react';
import './Login.css';

const Login = ({ onClose, onLoginSuccess, users, setLoginError, loginError, onSignupClick }) => { // Added onSignupClick prop
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        //check the data if they match or not

        const user = users.find((u) => u.email === email && u.password === password);

        if (user) {
            onLoginSuccess(email);
            onClose();
            setLoginError('');
        } else {
            setLoginError('Invalid credentials. Please try again.');
        }
    };

    return (
        <div className="login-container">
            <h2>Login</h2>
            {loginError && <p className="error-message">{loginError}</p>}
            <button className="close-button" onClick={onClose}>
                X
            </button>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn login-btn">
                    Log In
                </button>
                <p>
                    Don't have an account?{' '}
                    <button className="link-button" onClick={onSignupClick}> {/* Changed onClick to onSignupClick */}
                        Sign Up
                    </button>
                </p>
            </form>
        </div>
    );
};

export default Login;
